import React from 'react';
import { HelpResourceT } from '../utils/types';
import { getAvailableResources, getRef, getResourceValue } from './utils';
import {
  HelpTileContainer,
  RowCenter,
  DescriptionCenter,
  Data,
  Header,
  Title,
  Description,
} from './components';
import StationaryModal from '@as_core/elements/StationaryModal';
import { WistiaPlayer } from '@wistia/wistia-player-react';
import FeatureTagsAddEdit from '../components/FeatureTagsAddEdit';

interface PropsI {
  resource: HelpResourceT;
}

const debug = false;
const HelpTile = (props: PropsI) => {
  const { resource } = props;
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const availableResources = getAvailableResources(resource);
  if (debug) console.log('HelpTile | resource:', resource, ' availableResources:', availableResources);

  return (
    <HelpTileContainer>
      <Header>
        <FeatureTagsAddEdit featureTag={resource.features} />
        <RowCenter>
          <Title>{resource.name}</Title>
        </RowCenter>
      </Header>
      <DescriptionCenter>
        <Description>{resource.description}</Description>
      </DescriptionCenter>
      <Data>
        { availableResources.map((field) => (
          getRef(resource, field, setIsModalVisible)
        ))}
      </Data>
      <StationaryModal
        title={'Help Video'}
        width={700}
        height={440}
        modalOpen={isModalVisible}
        onCloseClick={() => setIsModalVisible(false)}
        zIndex={1400}
      >
        <WistiaPlayer width={400} mediaId={getResourceValue(resource, 'video')} />
      </StationaryModal>
    </HelpTileContainer>
  );
};

export default HelpTile;
